/*
 *   File : auth-layout.js
 *   Author : https://evoqins.com
 *   Description : auth layout component
 *   Integrations : NA
 *   Version : 1.0.1
 */

import React from "react";
import Logo from "../../Assets/Images/logo.png";
import { Outlet, Navigate } from "react-router-dom";
import Cookies from "js-cookie";

export default function AuthLayout() {
  const token = Cookies.get("access_token");

  //  Block auth pages if already logged in
  if (token) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="container-fluid d-flex min-vh-100 w-100 e-auth-bg">
      <div className="row flex-grow-1 w-100">
        {/* LEFT SECTION - visible on md, lg, xl (hidden only on sm & xs) */}
        <div className="col-xl-6 col-md-5 d-md-block d-none">
          <div className="row h-100">
            <div className="col-lg-10 offset-lg-1 offset-xl-2 col">
              <div className="d-flex flex-column justify-content-between h-100">
                {/* Logo */}
                <div className="row pt-132">
                  <div className="col-lg-4 col-md-6 col">
                    <img src={Logo} alt="FundsApp" className="img-fluid" />
                  </div>
                </div>

                {/* Text content */}
                <div className="row">
                  <div className="col">
                    <div className="d-flex flex-column row-gap-2 pb-80">
                      <h1 className="text-eerie-black mb-0 fw-500 fs-lg-32 fs-28">
                        Your Gateway to Smarter Funds.
                      </h1>

                      <p className="fs-lg-14 fs-12 fw-400 text-eerie-black mb-0">
                        {`FundsApp is designed to simplify and elevate your mutual fund investing experience. With intuitive tools, expert insights, and seamless access to top-performing funds, we empower users to make smarter, more confident investment decisions. Whether you're just starting out or looking to optimize your portfolio, FundsApp helps you invest with clarity, ease, and control.`}
                      </p>

                      <p className="fs-lg-16 fs-13 fw-400 text-eerie-black mb-0 pt-32">
                        © {new Date().getFullYear()} FundsApp. All rights reserved.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT SECTION */}
        <div className="col-xl-5 offset-xl-1 col-md-7 col pe-md-0 pe-2">
          <div className="h-100 w-100 e-glass-card e-auth-outlet">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
